import RandomCard from './RandomCard';
export default RandomCard;



// WEBPACK FOOTER //
// ./src/components/RandomCountries/RandomCard/index.js